import React from "react";
import { Box } from "@mui/material";
import axios from "../../utils/fvAxios";
import BaseURL from "../../utils/base-uri.json";
import PushPinOutlinedIcon from "@mui/icons-material/PushPinOutlined";
import FlagIcon from "@mui/icons-material/Flag";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import EmojiFlagsIcon from "@mui/icons-material/EmojiFlags";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import PushPinIcon from "@mui/icons-material/PushPin";

const postRequest = async (url, data) => {
    const response = await axios.post(url, data);
    return response.data;
};
export const pinUnPinMessage = (messageId, boolValue) => {  
    return postRequest(BaseURL.baseUrl + BaseURL.widget.PinUnpinMessage, {messageId,isPinned:boolValue});
};
export const flagUnflagMessage = (messageId, boolValue) => {
  return postRequest(BaseURL.baseUrl + BaseURL.widget.FlagUnflagMessage, {messageId,IsFlagged:boolValue});
};
export const deleteMessage = async (messageId) => {
  // const response = await axios.delete(BaseURL.baseUrl + BaseURL.widget.DeleteMessage +'?messageId='+messageId);
  // return response.data;
  return postRequest(BaseURL.baseUrl + BaseURL.widget.DeleteMessage + '?messageId='+messageId, {messageId});

};

export const messageContextOptions = [
  {
    name: "Pin",
    nameForTrueValue: "Unpin",
    icon: <PushPinOutlinedIcon />,
    iconForTrueValue: <PushPinIcon />,
  },
  {
    name: "Flag",
    nameForTrueValue: "Unflag",
    icon: <EmojiFlagsIcon />,
    iconForTrueValue: <FlagIcon />,
  },
  {
    name: "Edit",
    icon: <EditOutlinedIcon />,
    iconForTrueValue: <EditOutlinedIcon />,
  },
  {
    name: "Copy",
    icon: <ContentCopyIcon />,
    iconForTrueValue: <ContentCopyIcon />,
  },
  {
    name: "Delete",
    icon: <DeleteOutlineOutlinedIcon />,
    iconForTrueValue: <DeleteOutlineOutlinedIcon />,
  },
];
